import { EventEmitter } from "pixi.js";

export enum EnumRootEventBus {
  onVideoMode = "ON_VIDEO_MODE",
  setInfoSliderPage = "SET_INFO_SLIDER_PAGE",
  setInfoSliderPageWArr = "SET_INFO_SLIDER_PAGE_WITH_ARROW",
  setCurPage = "SET_CURRENT_PAGE",
  updateEdgeState = "UPDATE_EDGE_STATE",

  startedCircleAnim = "STARTED_CIRCLE_ANIMATION",
  completedCircleAnim = "COMPLETED_CIRCLE_ANIMATION",
  cancelledCircleAnim = "CANCELLED_CIRCLE_ANIMATION",
  closeSwitcher = "CLOSE_SWITCHER",
  setRedPointTag = "SET_RED_POINT_TAG",

  setRedPointCoord = "SET_RED_POINT_COORD",
  setRefRadians = "SET_REFERANCE_RADIANS",
  getCircleCoord = "GET_CIRCLE_COORD",
  drawElements = "DRAW_ELEMENTS",

  setPointerDown = "SET_POINTER_DOWN",
  setPointerMove = "SET_POINTER_MOVE",
  setPointerUp = "SET_POINTER_UP",

  setRulerLineStartCoord = "SET_RULER_LINE_START_COORD",
  setInteractLayer = "SET_INTERACTIVITY_COMPONENT_LAYER",

  topSwitcherButtonLabel = "TOP_SWITCHER_BUTTON_LABEL" // emit top switcher button label
}

export const rootEventBus = new EventEmitter();